module.exports = __webpack_public_path__ + "static/elon-musk-c399da570dae8a25b45fa51bee083975.jpg";